import { render, staticRenderFns } from "./TileGuestia.vue?vue&type=template&id=40d20d93&"
import script from "./TileGuestia.vue?vue&type=script&lang=js&"
export * from "./TileGuestia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports